import React from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Select, Button, Row, Tag, Table, Radio } from 'antd';

const HistoriaClinica = () => {
  return (
    <div>

      <Formik
        initialValues={[]}
        // validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting }) => { }}
      >
        {({ setFieldValue, isSubmitting, values }) => (
          <Form className="space-y-6 p-6 bg-white shadow-lg rounded-lg">
            {/* Sección Paciente */}
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Pacientes</label>
              <Select
                showSearch
                placeholder="Seleccione el paciente"
                options={[]}
                className="w-full"
                // filterOption={(input, option) =>
                //   (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                // }
                onChange={(value) => { }}
              />
              <ErrorMessage name="paciente" component="div" className="text-red-500 text-sm" />
            </div>

            {/* Información Básica */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Sucursal</label>
                <Field
                  as="select"
                  name="sucursal"
                  className="w-full p-2 border rounded"
                >
                  <option value="">Seleccionar sucursal</option>
                  {[
                    { id_sucursal: 1, nombre: "sucursal" }
                  ].map((sucursal) => (
                    <option key={sucursal.id_sucursal} value={sucursal.id_sucursal}>
                      {sucursal.nombre}
                    </option>
                  ))}
                </Field>
                <ErrorMessage name="sucursal" component="div" className="text-red-500 text-sm" />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Edad</label>
                <Field
                  name="edad"
                  className="w-full p-2 border rounded bg-gray-100"
                  readOnly
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de atención</label>
                <Field
                  name="fecha_atencion"
                  type="date"
                  className="w-full p-2 border rounded"
                  required
                />
              </div>
            </div>

            {/* Motivo de Consulta */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Motivo de Consulta:</label>
              <Field
                as="textarea"
                name="m_c"
                className="w-full p-2 border rounded min-h-[200px]"
                maxLength={10000}
                required
              />
            </div>

            {/* Fecha próxima cita */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de próxima cita</label>
                <Field
                  name="fecha_proxima_consulta"
                  type="date"
                  className="w-full p-2 border rounded"
                  required
                />
              </div>
            </div>

            {/* Servicios */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Servicios Realizados</label>
                <Select
                  showSearch
                  placeholder="Seleccionar servicio"
                  options={[]}
                  className="w-full"
                  onChange={(value, option) => { }}
                // filterOption={(input, option) =>
                //   (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                // }
                />
                <div className="flex flex-wrap gap-2 mt-2">
                  {[
                    { value: 1, label: "label" }
                  ].map(servicio => (
                    <Tag
                      key={servicio.value}
                      closable
                      onClose={() => { }}
                      className="flex items-center bg-white border border-gray-300 rounded-full px-3 py-1"
                    >
                      {servicio.label}
                    </Tag>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Próximos Servicios</label>
                <Select
                  showSearch
                  placeholder="Seleccionar servicio"
                  options={[]}
                  className="w-full"
                  onChange={(value, option) => { }}
                // filterOption={(input, option) =>
                //   (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                // }
                />
                <div className="flex flex-wrap gap-2 mt-2">
                  {[
                    { value: 1, label: "label" }
                  ].map(servicio => (
                    <Tag
                      key={servicio.value}
                      closable
                      onClose={() => { }}
                      className="flex items-center bg-white border border-gray-300 rounded-full px-3 py-1"
                    >
                      {servicio.label}
                    </Tag>
                  ))}
                </div>
              </div>
            </div>

            {/* Botón de envío */}
            <Button
              type="primary"
              htmlType="submit"
              loading={isSubmitting}
              disabled={isSubmitting}
              className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
            >
              Guardar Consulta
            </Button>

            {/* Estado del envío */}
            {/* {status === 'loading' && <p className="text-blue-500">Enviando...</p>}
            {status === 'failed' && <p className="text-red-500">Error: {"error"}</p>}
            {status === 'succeeded' && <p className="text-green-500">Creado con éxito</p>} */}
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default HistoriaClinica